import React, { useState, useEffect } from 'react';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      // If no consent is stored, show the banner
      setIsVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    // Store consent in localStorage
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const declineCookies = () => {
    // Store decline in localStorage
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white shadow-lg p-4 z-50 border-t-2 border-blue-500">
      <div className="container mx-auto flex flex-col md:flex-row items-center justify-between">
        <div className="mb-4 md:mb-0 md:mr-4">
          <h3 className="text-lg font-semibold mb-1">Cookie Notice</h3>
          <p className="text-sm text-gray-600">
            We use cookies to enhance your experience on our website. By continuing to browse, you agree to our use of cookies.
            You can learn more about how we use cookies in our <a href="#" className="text-blue-500 hover:underline">Privacy Policy</a>.
          </p>
        </div>
        <div className="flex space-x-3">
          <button
            onClick={declineCookies}
            className="px-4 py-2 border border-gray-300 rounded text-gray-700 hover:bg-gray-100 transition-colors"
          >
            Decline
          </button>
          <button
            onClick={acceptCookies}
            className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
          >
            Accept
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
